import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatSnackBar } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';
import { UserListFilterComponent } from '../user-list-filter/user-list-filter.component';
import * as XLSX from 'xlsx';
import { UtilityService } from 'src/app/services/utility/utility.service';
import _math from "lodash/math";

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
  displayedColumns = ['name', 'email', 'phonenumber', 'qualification', 'graduationyear', 'date',
    'percentage', 'campaignId'];
  filterParams = {
    camp_name: '',
    camp_source: '',
    camp_type: '',
    currentPinCode: '',
    end_date: '',
    permanentPinCode: '',
    strt_date: '',
    // usr_stage: []
  }
  userList: User[] = [];
  dataSource = new MatTableDataSource<User>(this.userList);
  filteredUserList: User[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild('table') table: ElementRef;

  constructor(private dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    private snackbar: MatSnackBar,
    private utilityService: UtilityService) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    // this.getUserList();
    this.getFilteredUserList({
      camp_name: '',
      camp_source: '',
      camp_type: '',
      end_date: '',
      loc: '',
      strt_date: ''
    });
  }
  openSnackBar(message: string) {
    if (message) {
      this.snackbar.open(message, null, {
        duration: 2000,
      });
    }
    else {
      this.snackbar.open('Network Error', null, {
        duration: 2000,
      });
    }
  }
  setFilterData(filter) {
    console.log("filter", filter);
    this.filterParams = {
      camp_name: filter.camp_name,
      camp_source: filter.camp_source,
      camp_type: filter.camp_type,
      currentPinCode: filter.currentPinCode,
      end_date: filter.end_date,
      permanentPinCode: filter.permanentPinCode,
      strt_date: filter.strt_date,
      // usr_stage: []
    }
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(UserListFilterComponent, {
      width: '400px',
      disableClose: true,
      data: this.filterParams
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != true) {
        this.setFilterData(result);
        this.getFilteredUserList(result);
      }
    })
  }

  getFilteredUserList(filter) {
    var data = {
      campaignName: filter.camp_name,
      campaignSource: filter.camp_source,
      campaignType: filter.camp_type,
      endDate: filter.end_date,
      currentPinCode: filter.currentPinCode,
      permanentPinCode: filter.permanentPinCode,
      startDate: filter.strt_date,
      // userStage: filter.usr_stage
    }
    this.spinnerService.show();
    var contentBody = { url: "/users/getallusers", body: data }
    // debugger;
    this.httpService.httpPost(contentBody, false).subscribe(response => {
      console.log("user response", response);
      let data = response;
      for (var i = 0; i < response.length; i++) {
        if (response[i].result != null && response[i].result != undefined && response[i].result.testReports != null &&
          response[i].result.testReports != undefined) {
          var array = response[i].result.testReports;
          // var lastResult = array.slice(-1)[0];
          var lastResult = array[0];
          //  console.log("lastResult", lastResult.testRecords);
          if (lastResult.testRecords != null) {
            // var testRecords = lastResult.testRecords;
            // // var testRecordsLast = testRecords.slice(-1)[0];
            // var testRecordsLast = testRecords[testRecords.length - 1];

            // if (testRecordsLast !== null && testRecordsLast !== undefined) {
            //   if (testRecordsLast.totalMarks > 0 && testRecordsLast.totalMarks !== undefined) {
            //     response[i].percentage = Math.round((+testRecordsLast.marks / testRecordsLast.totalMarks) * 100);
            //   }
            //   else {
            //     response[i].percentage = 0
            //   }
            // }

            let highestPercentageObjects = [];
            for (let j = 0; j < array.length; j++) {
              // console.log("data : ",array);
              // console.log("user data : ",array[j]);
              if(array[j].testRecords !== null){
                if (array[j].testRecords.length > 1) {
                  let tempObject ={
                    campaignId:"",
                    max:""
                  }
                  let max = _math.maxBy(array[j].testRecords, function (o) { return Math.round((+o.marks / o.totalMarks) * 100); });
                  tempObject.campaignId = array[j].campaignId;
                  if (max != undefined) {
                    tempObject.max = max;
                  } else {
                    tempObject.max = array[j].testRecords[0];
                  }
                  highestPercentageObjects.push(tempObject);
                  // console.log(response[i].fullName + " 144:", max);
                } else {
                  let tempObject ={
                    campaignId:"",
                    max:""
                  };
                  tempObject.campaignId = array[j].campaignId;
                  tempObject.max = array[j].testRecords[0];
                  highestPercentageObjects.push(tempObject);                
                }
              }

              // console.log(array[j].campaignId+" : ",_math.maxBy(array[j].testRecords, function (o) { return Math.round((+o.marks / o.totalMarks) * 100); }));
            }
            let object = null;
            if (highestPercentageObjects.length > 1) {
              // console.log(response[i].fullName + " :", _math.maxBy(highestPercentageObjects, function (o) { return Math.round((+o.marks / o.totalMarks) * 100); }));
              object = _math.maxBy(highestPercentageObjects, function (o) { return Math.round((+o.max.marks / o.max.totalMarks) * 100); });
            } else {
              // console.log(response[i].fullName + " :", highestPercentageObjects[0]);
              if(highestPercentageObjects.length == 1){
                object = highestPercentageObjects[0];
              }
            }
            console.log(object);
            if(object !== null && object !== undefined){
              if(object.max.totalMarks > 0){
                response[i].percentage = Math.round((+object.max.marks / object.max.totalMarks) * 100);
              }else{
                response[i].percentage = 0;
              }
              response[i].campaignId = object.campaignId;
            }else{
              response[i].percentage = 'NA';
              response[i].campaignId = 'NA';
            }
            
          }
          else {
            response[i].percentage = 'NA';
            response[i].campaignId = '';
          }

        } else {
          response[i].percentage = 'NA';
          response[i].campaignId = '';
        }
      }
      this.userList = response;
      // this.userList = this.userList.map(user => {
      //   if (user.result !== null)
      //     user.campaignId = user.result.testReports[0].campaignId;
      //   else
      //     user.campaignId = '';
      //   return user;
      // });
      this.dataSource = new MatTableDataSource(this.userList);
      this.dataSource.paginator = this.paginator;
      console.log("userList", this.userList);
      this.spinnerService.hide();

    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }

  applySearchFilter(filterValue: string) {
    console.log(filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // exportDataInExcel() {
  //   // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.getElementById('table'));
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.userList);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //   /* save to file */
  //   XLSX.writeFile(wb, 'UserList.xlsx');

  // }

  exportDataInExcel() {
    var tableHeader = ['Name', 'Email', '	Phone Number', 'Qualification',
      'Graduation Year', 'Date', 'Percentage', 'Campaign Id'];
    var rowOrder = ['fullName', 'emailId', 'phoneNumber', 'qualification',
      'graduationYear', 'updatedDate', 'percentage', 'campaignId'];
    var data = [];
    for (let index = 0; index < this.userList.length; index++) {
      var element = this.userList[index];
      var row = [];
      for (let index2 = 0; index2 < rowOrder.length; index2++) {
        row.push(element[rowOrder[index2]]);
      }
      data.push(row);
    }
    // console.log(this.utilityService.uigrid_to_sheet(data, tableHeader));

    var html_string = XLSX.utils.sheet_to_html(this.utilityService.uigrid_to_sheet(data, tableHeader),
      { id: "data-table", editable: true });
    // console.log(html_string);

    document.getElementById("container").innerHTML = html_string;
    var elt = document.getElementById('data-table');

    // var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
    var wb = XLSX.utils.table_to_book(elt);
    return XLSX.writeFile(wb, "UserList.xlsx");
  }
}
export interface User {
  cId: string;
  name: string;
  location: string;
  company: string;
  campaignId: string;
  result: Result;
}
export interface Result {
  id: string;
  testReports: TestReport[];
}
export interface TestReport {
  campaignId: string;
  testAttemptCount: Number;
}
